// extracted by mini-css-extract-plugin
export default {"menu":"pkc7uo5y9sCZVKTqlzPp","closeIcon":"KtfIvXW6_tjaQ8RnSM7Z"};